module.exports = __webpack_public_path__ + "img/icon-fishing-black.9f78e6ef.svg";